// Relevo entre el HTML prerenderizado y la app (docs/RENDIMIENTO.md, Fase 6).
//
// Las páginas prerenderizadas (scripts/prerender.js) ya traen el contenido y las imágenes.
// En vez de ocultarlas hasta que React termine (4-10 s en un celular), se muestran de inmediato:
//   1. El HTML prerenderizado (#root[data-prerendered]) queda visible.
//   2. La app se monta en un contenedor invisible, superpuesto y con su espacio normal (para que
//      el carrusel y las medidas funcionen), mientras carga sus datos de la API.
//   3. Cuando la página de la app está lista (hay contenido en <main> y ya no hay indicador de
//      carga) y las imágenes visibles están decodificadas, se intercambian en el mismo cuadro.
// Mientras tanto los enlaces del HTML prerenderizado funcionan como enlaces normales; los botones
// que dependen de JavaScript responden desde el intercambio.

const CHECK_EVERY_MS = 100;
const MAX_WAIT_MS = 10000;

const HIDDEN_STYLE = 'position:absolute;top:0;left:0;width:100%;visibility:hidden;pointer-events:none;';

const isAppReady = appRoot => {
    const main = appRoot.querySelector('main');
    return Boolean(main && main.children.length && !main.querySelector('.lds-ring'));
};

// Espera a que las imágenes del primer pantallazo estén decodificadas (máximo 1 s) para que el
// intercambio no muestre por un instante una imagen vacía.
const decodeVisibleImages = appRoot => {
    const visible = [...appRoot.querySelectorAll('img')].filter(img => {
        const rect = img.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight && img.currentSrc;
    });
    const decoded = Promise.all(visible.map(img => (img.decode ? img.decode().catch(() => {}) : null)));
    return Promise.race([decoded, new Promise(resolve => setTimeout(resolve, 1000))]);
};

export const mountApp = render => {
    const staticRoot = document.getElementById('root');
    if (!staticRoot.hasAttribute('data-prerendered')) {
        render(staticRoot);
        return;
    }

    const appRoot = document.createElement('div');
    appRoot.setAttribute('style', HIDDEN_STYLE);
    appRoot.setAttribute('aria-hidden', 'true');
    staticRoot.after(appRoot);
    render(appRoot);

    let swapped = false;
    let readyChecks = 0;
    const started = Date.now();

    const swap = () => {
        if (swapped) return;
        swapped = true;
        const scrollY = window.scrollY;
        staticRoot.remove();
        appRoot.removeAttribute('style');
        appRoot.removeAttribute('aria-hidden');
        appRoot.id = 'root';
        window.scrollTo(0, scrollY);
    };

    const check = () => {
        if (swapped) return;
        // Dos comprobaciones seguidas listas: deja que la página termine de asentarse.
        readyChecks = isAppReady(appRoot) ? readyChecks + 1 : 0;
        if (readyChecks >= 2) {
            decodeVisibleImages(appRoot).then(swap);
        } else if (Date.now() - started > MAX_WAIT_MS) {
            swap();
        } else {
            setTimeout(check, CHECK_EVERY_MS);
        }
    };
    setTimeout(check, CHECK_EVERY_MS);
};
